<template>
	<Content :style="{'padding': '10px'}">
	  <Breadcrumb :style="{margin: '5px 0'}">
	    <BreadcrumbItem>素材管理 > <b>任务详情</b></BreadcrumbItem>
	  </Breadcrumb>
	
	    <Card id="tableContent" >
	      <Form ref="task" :model="task" :rules="ruleValidate" :label-width="80">
			  <FormItem label="标题" prop="title">
			      <Input v-model="task.title" disabled  style="width: 600px" />
			  </FormItem>
	            <FormItem label="内容" prop="content">
	                <Input v-model="task.content" type="textarea" disabled :autosize="{minRows: 10,maxRows: 50}" style="width: 600px" />
	            </FormItem>
	           <FormItem label="素材" prop="mat">
				    <div class="demo-upload-list" v-for="(item,index) in task.mat">
						<template v-if="item.mat_type == '5'">
							   <img :src="item.mat_url">
						</template>
					   <template v-else>
						   <video width="200" height="200" :src="item.mat_url" controls></video>
					   </template>
					   <div class="demo-upload-list-cover" v-if="task.status==7">
						   <span style="color: #fff;font-weight: bold;">{{item.mat_name}}</span>
						   <Icon type="ios-trash-outline" @click.native="handleRemove(index)"></Icon>
					   </div>
				    </div>
	               <Upload :action="getUploadUrl" v-if="task.status==7" :headers="uploadHeader" :on-success="successUpload">
	                   <Button icon="ios-cloud-upload-outline">上传图片视频素材</Button>
	               </Upload>
	           </FormItem>  
	            <FormItem>
	                <Button type="primary" v-if="task.status==7" @click="updateTask(0)" >保存</Button>
					&nbsp;&nbsp;&nbsp;&nbsp;
					<Button type="warning" v-if="task.status==7" @click="updateTask(-1)" >素材匹配成功</Button>
	            </FormItem>
	        </Form>
	    </Card>
	</Content>
  
</template>

<script>
export default {
	data(){
		return {
			task:{
				id:0,
				mat:[],
				status:0
			},
			ruleValidate: {
				mat: [
					{ type: 'array',required: true, message: '请先上传素材', trigger: 'change' }
				]
			},
			uploadHeader:{
			  "Authorization":localStorage.getItem('token')
			},
		}
	},
	computed:{
		getUploadUrl(){
			return process.env.VUE_APP_APIHOST+'/admin/material/uploadPic';
		}
	},
	mounted(){
		let task_id = this.$route.query.task_id;
		if (typeof(task_id) != 'undefined') {
			this.getTaskInfo(task_id);
		}
	},
	methods:{  
		getTaskInfo(task_id) {
			this.http.get('/admin/material/taskInfo',{params:{task_id:task_id}}).then(response=>{
			  let data=response.data;
			  if(data.code!==0){
				alert(data.message);
			  } else{
				  console.log(data.data);
				this.task = data.data;
			  }
			}).catch(()=>{
			  this.$Message.error('网络错误');
			});
		},
		updateTask(status){
			this.$refs['task'].validate((valid) => {
				if (valid) {
					if (status == -1) {
						this.task.status = status;
					}
					this.http.post('/admin/material/editTask',this.task).then(response=>{
					  let data=response.data;
					  if(data.code!==0) {
					    this.$Message.error(data.message);
					    return false;
					  } else{
					    this.$Message.info(data.message);
						this.$router.push('/script/taskList')
					    return true;
					  }
					});
				} else {
					this.$Message.error('Fail!');
				}
			})
			
		},
		handleRemove (index) {
			this.task.mat.splice(index, 1);
		},
		successUpload(response, file, fileList){
			let data=response
			if(data.code!=0)
			{
				this.$Message.error(data.message);
				return true;
			}
			this.task.mat.push(data.data);
		},
	}
}
</script>
<style>
    .demo-upload-list{
        display: inline-block;
        width: 200px;
        height: 200px;
        text-align: center;
        line-height: 200px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .demo-upload-list img{
        width: 100%;
        height: 100%;
    }
    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
		height: 130px;
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
	textarea[disabled],textarea:disabled,textarea.disabled{  
	    color: #333;  
	    -webkit-text-fill-color:#333;  
	    -webkit-opacity:1;  
	    opacity: 1;  
	} 
</style>